/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer } from "ethers";
import { Provider } from "@ethersproject/providers";

import type { ISynthetix } from "../ISynthetix";

export class ISynthetix__factory {
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ISynthetix {
    return new Contract(address, _abi, signerOrProvider) as ISynthetix;
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "transferableSynthetix",
    outputs: [
      {
        internalType: "uint256",
        name: "transferable",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];
